var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.5C14.3978 2.5 14.7792 2.65815 15.0605 2.93945C15.3419 3.22076 15.5 3.60218 15.5 4V6.5H20V7.5H19.46L18.498 19.042C18.4872 19.6898 18.2265 20.3087 17.7676 20.7676C17.2987 21.2364 16.663 21.5 16 21.5H8C7.33696 21.5 6.70126 21.2364 6.23242 20.7676C5.77349 20.3086 5.51283 19.6898 5.50195 19.042L4.54004 7.5H4V6.5H8.5V4C8.5 3.60218 8.65815 3.22076 8.93945 2.93945C9.22076 2.65815 9.60218 2.5 10 2.5H14ZM6.49805 18.958L6.5 18.9795V19C6.5 19.3978 6.65815 19.7792 6.93945 20.0605C7.22076 20.3419 7.60218 20.5 8 20.5H16C16.3978 20.5 16.7792 20.3419 17.0605 20.0605C17.3419 19.7792 17.5 19.3978 17.5 19V18.9795L17.502 18.958L18.457 7.5H5.54297L6.49805 18.958ZM10.5 17H9.5V11H10.5V17ZM14.5 17H13.5V11H14.5V17ZM10 3.5C9.86739 3.5 9.74025 3.55272 9.64648 3.64648C9.55272 3.74025 9.5 3.86739 9.5 4V6.5H14.5V4C14.5 3.86739 14.4473 3.74025 14.3535 3.64648C14.2597 3.55272 14.1326 3.5 14 3.5H10Z",
    fill: "#FF5353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8f198a3f2b1c70eb3c9d063389bf5bcf.svg";
export { ForwardRef as ReactComponent };